import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeMode, handleClearAllValue } from 'redux/features/LoginSlice';
import { Button, CloseIcon, CustomPopover } from 'components';
import { ProfilePopoverContent } from './Header.style';
import DynModel from 'components/Modal';
import { UserProfile } from '../home/Home.style';
import { useTranslation } from 'react-i18next';
import { getProfile } from 'redux/features/ProfileSlice';
import { AuthContext } from 'router/AuthProvider';

import { ReactComponent as Profile } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as UserProfilePic } from 'assert/images/Navbar/userProfile.svg';
import { ReactComponent as Logout } from 'assert/images/Common/logout.svg';
import { ReactComponent as DarkTheme } from 'assert/images/Common/darkTheme.svg';
import { ReactComponent as LightTheme } from 'assert/images/Common/lightTheme.svg';
import { ReactComponent as Translation } from 'assert/images/Common/translation.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Arrowforward } from 'assert/images/Common/arrowForward.svg';
import { LanguageList } from 'assert/OptionList';
import clsx from 'clsx';
import useWindowDimensions from 'components/Dimention';

export default function HeaderProfile({ UserDetails }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const { width } = useWindowDimensions();

  const { isLoggedIn, recheckAuth } = useContext(AuthContext);

  const [openPopover, setOpenPopover] = useState(false);
  const [openLogoutModel, setOpenLogoutModel] = useState(false);
  const [showLanguageList, setShowLanguageList] = useState(false);
  const currentTheme = localStorage.getItem('mode');

  const profileList = [
    {
      icon: <UserProfilePic />,
      title: 'Profile',
      path: `/profile/${UserDetails?.username}`,
    },
    {
      icon: currentTheme === 'Dark' ? <LightTheme /> : <DarkTheme />,
      title: currentTheme === 'Dark' ? 'Light Mode' : 'Dark Mode',
      path: 'theme',
    },
    {
      icon: <Translation />,
      title: 'Language',
      path: 'language',
    },
    { icon: <Logout />, title: 'Logout', path: '/login' },
  ];

  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
    setShowLanguageList(false);
    setOpenPopover(false);
  };

  const handleLogout = () => {
    dispatch(handleClearAllValue())
      .then(() => {
        localStorage.removeItem('token');
        dispatch(getProfile(''));
        recheckAuth();
        navigate('/login');
      })
      .catch(() => {
        localStorage.removeItem('token');
        dispatch(getProfile(''));
        recheckAuth();
        navigate('/login');
      });
  };

  const redirectPage = (path) => {
    if (path === '/login') {
      setOpenLogoutModel(true);
      return;
    }
    navigate(path);
  };

  const onChangemode = () => {
    setOpenPopover(false);
    localStorage.setItem('mode', currentTheme === 'Dark' ? 'Light' : 'Dark');
    dispatch(changeMode(currentTheme === 'Dark' ? 'Light' : 'Dark'));
  };

  const profileMenu = () => {
    return (
      <ProfilePopoverContent>
        {(isLoggedIn ? profileList : profileList.slice(1, 3)).map(
          (data, index) => {
            return (
              <div
                className="profile-item"
                key={index}
                onClick={() => {
                  if (data.path === 'theme') {
                    onChangemode();
                  } else if (data.path === 'language') {
                    setShowLanguageList(true);
                  } else {
                    redirectPage(data.path);
                    setOpenPopover(false);
                  }
                }}
              >
                <div className="profile-content-item">
                  {data.icon}
                  <div>
                    <div>{data.title}</div>
                    {data.title === 'Profile' && width <= 500 ? (
                      <div className="preview-language">
                        {'@' + UserDetails?.username}
                      </div>
                    ) : (
                      <></>
                    )}
                    {data.title === 'Language' ? (
                      <div className="preview-language">
                        {
                          LanguageList.find((ele) => ele.value === language)
                            ?.label
                        }
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {data.title === 'Language' ? (
                  <Arrowforward className="profile-content-icon" />
                ) : (
                  ''
                )}
              </div>
            );
          }
        )}
      </ProfilePopoverContent>
    );
  };

  const renderLanguageList = () => {
    if (!showLanguageList) return null;

    return (
      <ProfilePopoverContent>
        <span
          className="language-close-icon"
          onClick={() => setShowLanguageList(false)}
        >
          <CloseIcon iconType={'back'} />
        </span>
        {LanguageList.map((lang) => (
          <div
            className={clsx(
              'language-item',
              language === lang.value && 'language-active-item'
            )}
            key={lang.value}
            onClick={() => handleLanguageChange(lang.value)}
          >
            {lang.label}
          </div>
        ))}
      </ProfilePopoverContent>
    );
  };

  return (
    <>
      <CustomPopover
        isOpen={openPopover}
        handlePopoverClick={() => setOpenPopover(true)}
        handlePopoverClose={() => {
          setOpenPopover(false);
          setTimeout(() => {
            setShowLanguageList(false);
          }, 500);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        className="header-profile-popover"
        action={
          isLoggedIn ? (
            <div className="profile-container">
              <div className="header-user-name-block">
                <div className="header-display-name">
                  {UserDetails?.displayName || UserDetails?.username}
                </div>
                <div className="header-user-name">@{UserDetails?.username}</div>
              </div>
              <UserProfile>
                {UserDetails?.profileImage ? (
                  <img
                    src={UserDetails?.profileImage}
                    className="profile-img"
                    alt="profile-picture"
                  />
                ) : (
                  <Profile />
                )}
              </UserProfile>
            </div>
          ) : (
            <div className="beforelogin-profile-container">
              <More />
            </div>
          )
        }
        content={showLanguageList ? renderLanguageList() : profileMenu()}
      />
      <DynModel
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setOpenLogoutModel(false)}
        openModal={openLogoutModel}
        content={
          <div className="confirmModal">
            <div className="title">{t('HomePage.LogoutFromWawfy')}</div>
            <div>
              <Button
                label={t('HomePage.Cancel')}
                variant="text"
                onClick={() => setOpenLogoutModel(false)}
              />
              <Button
                disableElevation
                label={t('HomePage.Yes')}
                color="error"
                onClick={handleLogout}
              />
            </div>
          </div>
        }
      />
    </>
  );
}
